import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import * as Actions from './actions'
import { IBottle } from 'app/models/bottle';
import * as fromLoation from 'app/state/location/reducer';
import * as fromBeverage from 'app/state/beverage/reducer';

export interface State extends EntityState<IBottle> {
  // additional entity state properties
  selectedId: string | null;
  ean: string;
  error: string;
}


export function sortByName(a: IBottle, b: IBottle): number {
  return a.name.localeCompare(b.name);
}
export function selectId(a: IBottle): string {
  return a.id ?? '';
}
export const adapter: EntityAdapter<IBottle> = createEntityAdapter<IBottle>({
  sortComparer: sortByName,
  selectId: selectId
});

export const initialState: State = adapter.getInitialState({
  selectedId: null,
  ean: '',
  error: '',
});

export const stateName = 'bottle';

export const reducer = createReducer<State>(
  initialState,
  on(Actions.clearAllItems, (state) => {
    return adapter.removeAll(state);
  }),

  on(Actions.loadItemsSuccess, (state, { items }) => {
    return adapter.setAll(items, state);
  }),

  on(Actions.loadItemsFailure, (state, { error }) => {
    return { ...state, error: error };
  }),

  on(Actions.setItem, (state, action) => {
    return Object.assign({ ...state, selectedId: action.id });
  }),
  on(Actions.setEan, (state, action) => Object.assign({ ...state, ean: action.ean })),

  on(Actions.setError, (state, action) => {
    return Object.assign({ ...state, error: action.error });
  }),

);

// get the selectors
const { selectAll, selectEntities } = adapter.getSelectors();

const selectState = createFeatureSelector<State>(stateName);
export const getSelectedId = (state: State) => state.selectedId;
export const getEan = (state: State) => state.ean;
export const getError = (state: State) => state.error;

export const getState = createFeatureSelector<State>(stateName);
export const selectAllItems = createSelector(getState, selectAll);
export const selectAllEntities = createSelector(getState, selectEntities);
export const getCurrentId = createSelector(getState, getSelectedId);
export const selectEan = createSelector(getState, getEan);
export const selectError = createSelector(getState, getError);

export const selectCurrentItem = createSelector(selectAllEntities, getCurrentId, (entities, id) => {
  if (id) return entities[id];
  return null;
});


export const selectEntity = (id: string) => createSelector(selectAllEntities, entities => entities[id]);

export const selectAllItemsForBeverage = (beverageId: string) =>
  createSelector(selectAllItems, items => items.filter(i => i.beverageId === beverageId));

export const selectAllItemsForCurrentBeverage =
  createSelector(
    selectAllItems,
    fromBeverage.selectCurrentId,
    (items, beverageId) => {
      return items.filter(i => i.beverageId === beverageId);
    });

export const selectAllItemsFromCurrentLocation =
  createSelector(
    selectAllItems,
    fromLoation.selectCurrentId,
    (items, locationId) => {
      return items.filter(i => i.locationId === locationId) as IBottle[];
    });
